import { render, staticRenderFns } from "./form-save-modal.vue?vue&type=template&id=7bc66966&scoped=true&"
import script from "./form-save-modal.vue?vue&type=script&lang=js&"
export * from "./form-save-modal.vue?vue&type=script&lang=js&"
import style0 from "./form-save-modal.vue?vue&type=style&index=0&id=7bc66966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc66966",
  null
  
)

export default component.exports